import React from 'react';

function BancontactCard(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="32" height="20" viewBox="0 0 32 20" {...props}>
      <defs>
        <linearGradient
          id="bancontact-gradient-1"
          x1="20.224%"
          y1="50.7442077%"
          x2="93.384%"
          y2="39.8270186%"
        >
          <stop stopColor="#005AB9" offset="0%" />
          <stop stopColor="#1E3764" offset="100%" />
        </linearGradient>
        <linearGradient
          id="bancontact-gradient-2"
          x1="6.056%"
          y1="59.4721725%"
          x2="83.728%"
          y2="48.8250198%"
        >
          <stop stopColor="#FBA900" offset="0%" />
          <stop stopColor="#FFD800" offset="100%" />
        </linearGradient>
      </defs>
      <path
        d="M29.6159726,0.500069536 C30.1145752,0.495886197 30.5950536,0.680218729 30.9469175,1.01491903 C31.2967569,1.3485237 31.4969409,1.79823123 31.5,2.26594503 L31.5000356,17.7410067 C31.4942156,18.2288558 31.2820848,18.6675724 30.9471212,18.9841043 C30.6049799,19.307419 30.1350077,19.5039917 29.6158625,19.4999193 L2.38282468,19.4999356 C1.8843102,19.5039598 1.40666423,19.3191384 1.05249967,18.9845393 C0.703941317,18.6532257 0.504221501,18.20188 0.5,17.7340682 L0.499979665,2.26787385 C0.504217592,1.79799581 0.704073146,1.34824001 1.05445801,1.01619606 C1.405547,0.681373971 1.88464924,0.496758326 2.38549911,0.500087134 Z"
        stroke="#DDDDDD"
        fill="#FFFFFF"
        fillRule="nonzero"
      />
      <g fillRule="evenodd" transform="translate(3, 4)">
        <path
          d="M14,7.023 C12.216,9.393 10.062,12.046 5.966,12.046 L1,12.046 C0.44771525,12.046 0,11.5982847 0,11.046 L0,6.023 C0,5.47071525 0.44771525,5.023 1,5.023 L13,5.023 C14.784,2.653 16.94,0 21.034,0 L26,0 C26.5522847,0 27,0.44771525 27,1 L27,6.023 C27,6.57528475 26.5522847,7.023 26,7.023 L14,7.023 Z"
          fill="#FFFFFF"
          fillRule="nonzero"
        />
        <path
          d="M5.966,11.046 C9.733,11.046 11.616,8.534 13.5,6.023 L1,6.023 L1,11.046 L5.966,11.046 Z"
          fill="url(#bancontact-gradient-1)"
          fillRule="nonzero"
        />
        <path
          d="M21.034,1 C17.267,1 15.384,3.511 13.5,6.023 L26,6.023 L26,1 L21.034,1 Z"
          fill="url(#bancontact-gradient-2)"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
}

export default BancontactCard;
